var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620-140v-120H460v-400H340v120H100v-280h240v120h280v-120h240v280H620v-120H500v360h120v-120h240v280H620ZM140-780v200-200Zm520 400v200-200Zm0-400v200-200Zm0 200h160v-200H660v200Zm0 400h160v-200H660v200ZM140-580h160v-200H140v200Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTree);
export default __webpack_public_path__ + "static/media/account_tree.25b0ce711ad3d20a87f24b64687dfb5f.svg";
export { ForwardRef as ReactComponent };